export enum ModalActionNames {
  OPEN_MODAL = 'OPEN_MODAL',
  CLOSE_MODAL = 'CLOSE_MODAL',
}

export interface Modal {
  open: boolean;
  message: string | JSX.Element;
  accept?: Function;
  acceptButtonText?: string;
  cancel?: Function;
  cancelButtonText?: string;
}

interface SetModalOpen {
  type: typeof ModalActionNames.OPEN_MODAL;
  payload: Modal;
}

interface SetModalClosed {
  type: typeof ModalActionNames.CLOSE_MODAL;
  payload: boolean;
}

export type ModalActionTypes = SetModalClosed | SetModalOpen;
